import Vue from "vue";
import Component from "vue-class-component";
import { mapGetters } from "vuex";

import ConfirmationAppointImage from "@/assets/images/appoint_confirmation.png";
import CheckGif from "@/assets/gifs/gif_check.gif";
import FireworksGif from "@/assets/gifs/gif_fireworks_.gif";
import GoogleAnalyticsEvents from "@/helpers/GoogleAnalyticsEvents";

const ComponentProps = Vue.extend({
  props: {},
});

@Component({
  name: "AppointConfirmationComponent",
  computed: mapGetters([
    "getSearchDate",
  ]),
})
export default class AppointConfirmationComponent extends ComponentProps {
  cx_image = ConfirmationAppointImage;
  cx_checkGif = CheckGif;
  cx_fireworksGif = FireworksGif;

  goHome(): void {
    GoogleAnalyticsEvents.returnHomePage();
    window.location.href = "https://saude.clinicarx.com.br";
  }

  closeAppoint(): void {
    this.$store.commit("setTime", {});
    document.getElementsByClassName("selected-time")[0]?.classList.remove("selected-time");
    GoogleAnalyticsEvents.newAppointment();
    this.$emit("close", false);
  }
}
